const CNPJ_LENGTH = 14
const CNPJ_ROOT_LENGTH = 8
const CNPJ_BASE_LENGTH = 12
const CNPJ_FIRST_DV_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
const CNPJ_SECOND_DV_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]


function calculateCnpjCheckDigit(base) {
    const weights =
        base.length === CNPJ_BASE_LENGTH
            ? CNPJ_FIRST_DV_WEIGHTS
            : CNPJ_SECOND_DV_WEIGHTS

    const sum = base
        .split('')
        .reduce(
            (acc, char, index) =>
                acc + ((char.toUpperCase().codePointAt(0) ?? 0) - 48) * weights[index],
            0,
        )

    const remainder = sum % 11
    return remainder < 2 ? 0 : 11 - remainder
}

export function normalizeCnpj(value) {
    if (!value) return ''
    return String(value).toUpperCase().replaceAll(/[^A-Z0-9]/g, '')
}

export function getCnpjBase(value) {
    const normalized = normalizeCnpj(value)
    return normalized.length >= CNPJ_ROOT_LENGTH
        ? normalized.slice(0, CNPJ_ROOT_LENGTH)
        : null
}

export function formatCnpj(value) {
    const normalized = normalizeCnpj(value)
    if (normalized.length !== CNPJ_LENGTH) {
        return value ? String(value) : ''
    }

    return normalized.replace(
        /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
        '$1.$2.$3/$4-$5',
    )
}

export function isValidCNPJ(cnpj) {
    const normalized = normalizeCnpj(cnpj)

    if (normalized.length !== CNPJ_LENGTH) {
        return false
    }

    if (!/^[A-Z0-9]{12}\d{2}$/.test(normalized)) {
        return false
    }

    const base = normalized.substring(0, CNPJ_BASE_LENGTH)
    if (/^(.)\1+$/.test(base)) {
        return false
    }

    const checkDigits = normalized.substring(CNPJ_BASE_LENGTH)
    const firstDigit = calculateCnpjCheckDigit(base)
    const secondDigit = calculateCnpjCheckDigit(base + firstDigit)

    return checkDigits === `${firstDigit}${secondDigit}`
}

export function isValidCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '')
    if (cpf === '') return false

    if (cpf.length !== 11) return false

    if (
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999'
    ) {
        return false
    }

    let add = 0
    for (let i = 0; i < 9; i++) {
        add += parseInt(cpf.charAt(i)) * (10 - i)
    }
    let rev = 11 - (add % 11)
    if (rev === 10 || rev === 11) {
        rev = 0
    }
    if (rev !== parseInt(cpf.charAt(9))) {
        return false
    }

    add = 0
    for (let i = 0; i < 10; i++) {
        add += parseInt(cpf.charAt(i)) * (11 - i)
    }
    rev = 11 - (add % 11)
    if (rev === 10 || rev === 11) {
        rev = 0
    }
    if (rev !== parseInt(cpf.charAt(10))) {
        return false
    }

    return true
}

export function isValidUFs(uf) {
    const validUFs = [
        'AC',
        'AL',
        'AP',
        'AM',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MT',
        'MS',
        'MG',
        'PA',
        'PB',
        'PR',
        'PE',
        'PI',
        'RJ',
        'RN',
        'RS',
        'RO',
        'RR',
        'SC',
        'SP',
        'SE',
        'TO',
    ]
    return validUFs.includes(uf)
}

export function isValidDate(dateStr) {
    if (dateStr.length !== 8 || !/^\d+$/.test(dateStr)) {
        return false
    }

    const day = parseInt(dateStr.substr(0, 2), 10)
    const month = parseInt(dateStr.substr(2, 2), 10)
    const year = parseInt(dateStr.substr(4, 4), 10)

    if (month < 1 || month > 12) {
        return false
    }

    const lastDayOfMonth = new Date(year, month, 0).getDate()

    if (day < 1 || day > lastDayOfMonth) {
        return false
    }

    if (year < 1000 || year > 9999) {
        return false
    }

    return true
}
